import classNames from "classnames";

export const DASHBOARD_PANEL_SHELL_CLASS = classNames(
  "w-full min-w-0 overflow-hidden rounded-lg border border-extended-pgadarknavy-brand-color bg-sys-brand-surface"
);

/** Extra scroll room below the last dashboard panel (bottom bar, safe area, and touch scrolling). */
export const DASHBOARD_BOTTOM_SCROLL_PADDING_CLASS =
  "pb-[calc(8rem+env(safe-area-inset-bottom,0px))] lg:pb-[calc(5rem+env(safe-area-inset-bottom,0px))]";

/** @deprecated Use `DASHBOARD_PANEL_SHELL_CLASS` */
export const DASHBOARD_PANEL_SECTION_CLASS = DASHBOARD_PANEL_SHELL_CLASS;

export const DASHBOARD_PANEL_HEADER_CLASS = "flex w-full items-center justify-between gap-2 px-4 pb-3 pt-4 lg:py-3";

export const DASHBOARD_PANEL_BODY_CLASS = "max-w-full overflow-x-auto";

export const DASHBOARD_TABLE_CONTENT_CELL = "py-3 align-top text-left text-body-medium text-sys-brand-on-surface";

export const DASHBOARD_TABLE_META_CELL =
  "w-28 whitespace-nowrap align-middle py-3 text-left text-body-medium text-sys-brand-on-surface";
